<template>
  <MultiImageSliderStrip
    v-if="configuration.carousel"
    :slides-data="records"
    :slider-breakpoints="sliderBreakpoints">
    <template #card-slide="{ record }">
      <FrameCard
        :key="record.id"
        :badge-content="record.badgeContent"
        :image="record.path"
        :alt="record.alt"
        :instagram="record.instagram"
        :facebook="record.facebook"
        :date="record.date"
        :title="record.mainTitle"
        :href="record.href"
        :aria-label="linkText"></FrameCard>
    </template>
  </MultiImageSliderStrip>
  <div v-else class="s-news-article__grid">
      <FrameCard
        v-for="record in records"
          :key="record.id"
          :badge-content="record.badgeContent"
          :image="record.path"
          :alt="record.alt"
          :instagram="record.instagram"
          :facebook="record.facebook"
          :date="record.date"
          :title="record.mainTitle"
          :href="record.href"
          :aria-label="linkText"></FrameCard>
    </div>
</template>

<script setup>
import {getCurrentInstance, onBeforeMount, ref  } from 'vue'
import MultiImageSliderStrip from '../components/MultiImageSliderStrip.vue'
import FrameCard from '../components/UI/FrameCard.vue'
import { getData } from '../../lib/lib'
const {configuration, dictionary, suffix } = getCurrentInstance().appContext.config.globalProperties
const records = ref([])

const linkText = ref(dictionary.linkText)
const sliderBreakpoints = ref({
  200: {
    slidesPerView: 1.05,
    spaceBetween: 8,
  },
  320: {
    slidesPerView: 1.05,
    spaceBetween: 8,
  },
  576: {
    slidesPerView: 1.5,
    spaceBetween: 16,
  },
  768: {
    slidesPerView: 2.2,
    spaceBetween: 16,
  },
  992: {
    slidesPerView: 3.2,
    spaceBetween: 32,
  },
  1279: {
    slidesPerView: 4,
    spaceBetween: 32,
  },
})

onBeforeMount(() => {
  const {records: cards } = getData(`multiCardSliderData${suffix}`)
  records.value = [...cards]
})
</script>
